module.exports = __webpack_public_path__ + "assets/img/sanitary_21.84df52fb.jpg";